/** Resumo lateral do pedido — só na web; no celular o rodapé fixo cumpre esse papel. */
export default function ResumoPedido({
  planoNome,
  titulo,
  quando,
  sessao,
  campoCupom,
  cupom,
  subtotal,
  desconto,
  total,
}) {
  return (
    <aside className="sticky top-8 flex flex-col gap-3.5 rounded-[28px] border border-[#eef0f4] bg-white p-6 shadow-[0_20px_50px_rgba(255,35,104,.06)]">
      <h2 className="m-0 text-sm font-extrabold uppercase tracking-[.04em] text-[#0f1729]">
        Resumo do pedido
      </h2>

      <div className="flex flex-col gap-1.5 border-t border-[#eef0f4] pt-3">
        {planoNome && (
          <span className="self-start rounded-full bg-[#fff0f4] px-2 py-[3px] text-[9px] font-bold uppercase text-[#ff2368]">
            {planoNome}
          </span>
        )}
        <span className="text-base font-bold leading-[1.3] text-[#0f1729]">
          {titulo}
        </span>
        {quando && <span className="text-xs text-[#4b5568]">{quando}</span>}
        {sessao && (
          <span className="text-xs text-[#4b5568]">Sessão: {sessao}</span>
        )}
      </div>

      {campoCupom}

      {cupom && (
        <div className="flex flex-col gap-1 text-xs tabular-nums">
          <div className="flex justify-between text-[#8a94a8]">
            <span>Subtotal</span>
            <s>R$ {subtotal}</s>
          </div>
          <div className="flex justify-between font-bold text-emerald-700">
            <span>Cupom {cupom.codigo}</span>
            <span>− R$ {desconto}</span>
          </div>
        </div>
      )}

      <div className="flex items-baseline justify-between border-t border-[#eef0f4] pt-3">
        <span className="text-[11px] font-bold uppercase text-[#8a94a8]">
          Total
        </span>
        <span className="text-2xl font-extrabold tabular-nums text-[#0f1729]">
          {total ? `R$ ${total}` : '—'}
        </span>
      </div>
    </aside>
  );
}
